<template>
  <!--  <div>ssss</div>-->
  <div>
    <top-header></top-header>
    <el-row class="search-container">
      <el-col :span="21">
        <el-row style="padding-top: 20px;padding-left: 20px;">
          <span>课程名称：</span>
          <el-input v-model="searchInfo.searchTitleKey" style="width: 200px"></el-input>
          <span style="padding-left: 20px">直播时间：</span>
          <el-date-picker style="width: 380px"
                          v-model="searchInfo.searchDateRange"
                          type="datetimerange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['8:00:00','20:00:00']">
          </el-date-picker>
        </el-row>
        <el-row style="padding-left: 20px;padding-top: 20px">
          <span style="width: 200px">课程类型：</span>
          <el-select v-model="searchInfo.searchTypeKey" style="width: 200px" placeholder="请选择">
            <el-option
              v-for="item in courseTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <span style="padding-left: 20px">课程状态：</span>
          <el-select v-model="searchInfo.searchStatusKey" placeholder="请选择" style="width: 380px;padding-right: 20px">
            <el-option
              v-for="item in courseStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-row>
      </el-col>
      <el-col :span="3" >
        <el-button type="primary" style="margin-top: 50px;margin-left: 60px" @click="searchBtnClick">搜索</el-button>
      </el-col>
    </el-row>
    <el-button
      type="primary"
      icon="el-icon-plus" style="margin-top: 10px;margin-left: 20px"
      @click="handleAddCourse">创建课程</el-button>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266',textAlign:'center'}"
        style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="cen" inline class="demo-table-expand">
              <el-form-item label="课程编号">
                <span>{{ props.row.Id }}</span>
              </el-form-item>
              <el-form-item label="首节课时间">
                <span>{{ getFirstLiveTime(props.row.FirstLiveTime) }}</span>
              </el-form-item>
              <el-form-item label="课程名称">
                <span>{{ props.row.Title }}</span>
              </el-form-item>
              <el-form-item label="到期时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.Expire) }}</span>
              </el-form-item>
              <el-form-item label="课程类型">
                <span>{{ getCourseTypeStr(props.row.Type) }}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.CreateTime) }}</span>
              </el-form-item>
              <el-form-item label="最大人数">
                <span>{{ props.row.MaxUserNum }}</span>
              </el-form-item>
              <el-form-item label="更新时间">
                <span>{{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.UpdateTime) }}</span>
              </el-form-item>
              <el-form-item label="课程描述">
                <span>{{ props.row.Detail }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="课程封面" width="120">
          <template slot-scope="props">
            <div style="text-align: center">
<!--              <el-image src="https://uploadimg.koolearn.com/upload/2019-11-07/809e62e70fe48561539eeb4011dda72e.jpg" style="width: 60px;height: 60px;">-->
              <el-image v-bind:src="props.row.HeadImg" style="width: 60px;height: 60px;">
                <div slot="error">
                  <img src="../../assets/course/default_course_image.png" style="width: 60px;height: 60px;"/>
                </div>
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="课程名称">
          <template slot-scope="props">
            <div style="text-align: center">
              <span>{{ props.row.Title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="课堂类型" width="100">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ getCourseTypeStr(props.row.Type) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="最大人数" width="100">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ props.row.MaxUserNum}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="创建人" width="100">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ props.row.CreateUser}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="更新时间"
          width="160">
          <template slot-scope="props">
            <p> {{ formatDate('YYYY-mm-dd HH:MM:SS',props.row.UpdateTime) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="状态" width="100">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ props.row.Status === 1 ? '有效' : '无效'}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleModifyCourse(scope.$index, scope.row)">修改课程</el-button>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleLiveManager(scope.$index, scope.row)">直播管理</el-button>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleStuManager(scope.$index, scope.row)">学生管理</el-button>
            <el-button
              size="mini"
              type="danger" plain
              @click="handleDeleteCourse(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="创建课程" :visible.sync="dialogAddCourseVisible">
      <courser-info-component v-bind:is-add="true"
                              v-bind:course-info="addCourseModel"
                              @CancleBtnClick="dialogAddCourseVisible = false"
                              @OKBtnClick="addCourseOkBtnClick" ></courser-info-component>
    </el-dialog>
    <el-dialog title="修改课程" :visible.sync="dialogModifyCourseVisible">
      <courser-info-component v-bind:is-add="false"
                              v-bind:course-info="modifyCourseModel"
                              @CancleBtnClick="dialogModifyCourseVisible = false"
                              @OKBtnClick="modifyCourseOkBtnClick" ></courser-info-component>
    </el-dialog>
    <el-dialog title="学生管理" :visible.sync="dialogAddStudentVisible">
      <select-user-component ref="addStudentView"
                             @selected="studentSelect"
                             @unSelected="studentNnSelected"
                             @unSelectPageChange="studentNnSelectPageChange"
                             @selectPageChange="studentSelectPageChange"
                             @searchUnSelectClick="studentSearchUnSelectClick"
                             @searchSelectClick="studentSearchSelectClick"></select-user-component>
    </el-dialog>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
import CourserInfoComponent from '../../components/course/CourserInfoComponent'
import SelectUserComponent from '../../components/selectuser/SelectUserComponent'
export default {
  name: 'CourseManager',
  components: {CourserInfoComponent, TopHeader, SelectUserComponent},
  data () {
    return {
      dataList: [],
      currentPage: 1,
      pageCount: 10,
      totalCount: 0,
      dialogAddCourseVisible: false,
      dialogModifyCourseVisible: false,
      addCourseModel: {Name: '', Type: 0, HeadImg: '', MaxUserNum: 2},
      modifyCourseModel: {},
      delCourseModel: {},
      searchInfo: {searchTypeKey: -1, searchStatusKey: -1},
      courseTypeList: [{label: '全部', value: -1}, {label: '小班课', value: 0}, {label: '大班课', value: 1}, {label: '公开课', value: 2}],
      courseStatusList: [{label: '全部', value: -1}, {label: '有效', value: 1}, {label: '无效', value: 0}],
      dialogAddStudentVisible: false,
      curCourseIdByAddStu: 0
    }
  },
  created () {
    this.getCourseList()
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/courseop') {
          that.getCourseList()
        }
      },
      deep: true
    }
  },
  methods: {
    getCourseList () {
      let title = this.searchInfo.searchTitleKey
      let dateRange = this.searchInfo.searchDateRange
      let courseType = this.searchInfo.searchTypeKey
      let courseStatus = this.searchInfo.searchStatusKey

      let requestData = {count: this.pageCount, page: this.currentPage}
      if (title !== undefined) {
        requestData.title = title
      }
      if (courseType !== -1) {
        requestData.type = courseType
      }
      if (courseStatus !== -1) {
        requestData.status = courseStatus
      }
      if (dateRange !== undefined && dateRange.length > 1) {
        requestData.begintime = this.formatDate('YYYY-mm-dd HH:MM:SS', dateRange[0])
        requestData.endtime = this.formatDate('YYYY-mm-dd HH:MM:SS', dateRange[1])
      }
      this.$api.courseManager.searchCourse(requestData).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data
          this.totalCount = res.count
        }
      })
    },
    searchBtnClick () {
      this.getCourseList()
    },
    handleSizeChange (val) {
      this.pageCount = val
      this.currentPage = 1
      this.getCourseList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getCourseList()
    },
    handleAddCourse () {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogAddCourseVisible = true
    },
    addCourseOkBtnClick () {
      if (this.addCourseModel.Title === undefined || this.addCourseModel.Title === '') {
        this.$message.error('请输入课程名')
        return
      }
      if (this.addCourseModel.Title.length > 30) {
        this.$message.error('课程标题不能超过30字')
        return
      }
      if (this.addCourseModel.Detail !== '' && this.addCourseModel.Detail !== undefined && this.addCourseModel.Detail.length > 200) {
        this.$message.error('课程描述不能超过200字')
        return
      }
      if (this.addCourseModel.Expire === undefined){
        this.$message.error('课程有效期不能为空')
        return
      }
      if (this.addCourseModel.Expire.getTime() < new Date().getTime() ){
        this.$message.error('课程有效期不能小于当前时间')
        return
      }
      let expireTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.addCourseModel.Expire)
      let requestData = {
        type: this.addCourseModel.Type,
        title: this.addCourseModel.Title,
        headimg: this.addCourseModel.HeadImg,
        detail: this.addCourseModel.Detail,
        maxusernum: Number(this.addCourseModel.MaxUserNum),
        expire: expireTime}
      this.$api.courseManager.addCourse(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.addCourseModel = {Name: '', Type: 0, HeadImg: '', MaxUserNum: 2}
          this.getCourseList()
          this.dialogAddCourseVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleModifyCourse (index, row) {
      this.$api.home.interCheck().then((res) => {

      })
      this.dialogModifyCourseVisible = true
      this.modifyCourseModel = row
    },
    modifyCourseOkBtnClick () {
      if (this.modifyCourseModel.Title === undefined || this.modifyCourseModel.Title === '') {
        this.$message.error('请输入课程名')
        return
      }
      if (this.modifyCourseModel.Title.length > 30) {
        this.$message.error('课程标题不能超过30字')
        return
      }
      if (this.modifyCourseModel.Detail !== '' && this.modifyCourseModel.Detail !== undefined && this.modifyCourseModel.Detail.length > 200) {
        this.$message.error('课程描述不能超过200字')
        return
      }
      if (this.modifyCourseModel.Expire === undefined) {
        this.$message.error('课程有效期不能为空')
        return
      }
      // if (this.modifyCourseModel.Expire.getTime() < new Date().getTime() ) {
      //   this.$message.error('课程有效期不能小于当前时间')
      //   return
      // }
      let expireTime = this.formatDate('YYYY-mm-dd HH:MM:SS', this.modifyCourseModel.Expire)
      let requestData = {
        id: this.modifyCourseModel.Id,
        title: this.modifyCourseModel.Title,
        headimg: this.modifyCourseModel.HeadImg,
        detail: this.modifyCourseModel.Detail,
        maxusernum: Number(this.modifyCourseModel.MaxUserNum),
        expire: expireTime}
      this.$api.courseManager.modifyCourse(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getCourseList()
          this.dialogModifyCourseVisible = false
        }
      })
    },
    handleDeleteCourse (index, row) {
      this.delCourseModel = row
      let alertStr = '确定要删除   "' + this.delCourseModel.Title + '"   课程吗？'
      this.$confirm(alertStr, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delCourseOKBtn()
      }).catch(() => {

      })
    },
    delCourseOKBtn () {
      let requestData = {id: this.delCourseModel.Id}
      this.$api.courseManager.delCourse(requestData).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getCourseList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleLiveManager (index, row) {
      this.$router.push({path: '/liveCourse', query: {courseId: row.Id, courseName: row.Title}})
    },
    // 添加学生相关
    handleStuManager (index, row) {
      this.curCourseIdByAddStu = row.Id
      this.dialogAddStudentVisible = true
      if (this.$refs.addStudentView === undefined) {
        let that = this
        setTimeout(function () {
          that.getunAddedStu(5, 1)
          that.getAddedStu(5, 1)
        }, 100)
      } else {
        this.getunAddedStu(5, 1)
        this.getAddedStu(5, 1)
      }
    },
    getunAddedStu (count, page) {
      let searchKey = this.$refs.addStudentView.searchVal
      if (searchKey !== undefined && searchKey !== '') {
        let requestData = {id: this.curCourseIdByAddStu, count: count, page: page, key: searchKey}
        this.$api.courseManager.getUnAddedStuBySearchCourse(requestData).then((res) => {
          if (res.code === 0) {
            let allStu = res.data
            this.$refs.addStudentView.setUnSelectList(allStu, res.count)
          }
        })
      } else {
        let requestData = {id: this.curCourseIdByAddStu, count: count, page: page}
        this.$api.courseManager.getUnAddedStuByCourse(requestData).then((res) => {
          if (res.code === 0) {
            let allStu = res.data
            this.$refs.addStudentView.setUnSelectList(allStu, res.count)
          }
        })
      }
    },
    getAddedStu (count, page) {
      let searchKey = this.$refs.addStudentView.searchRightVal
      if (searchKey !== '') {
        let requestData = {count: count, page: page, courseid: this.curCourseIdByAddStu, key: searchKey}
        this.$api.courseManager.getAddedStuBySearchCourse(requestData).then((res) => {
          if (res.code === 0) {
            this.$refs.addStudentView.setSelectList(res.data, res.count)
          }
        })
      } else {
        let requestData = {count: count, page: page, courseid: this.curCourseIdByAddStu}
        this.$api.courseManager.getAddedStuByCourse(requestData).then((res) => {
          if (res.code === 0) {
            this.$refs.addStudentView.setSelectList(res.data, res.count)
          }
        })
      }
    },
    studentSelect (item) {
      let requestData = {userid: item.Id, courseid: this.curCourseIdByAddStu}
      this.$api.courseManager.addStuToCourse(requestData).then((res) => {
        if (res.code === 0) {
          // 重新获取未添加到直播的学生
          this.$refs.addStudentView.selectedSuccess(item)
          let unSelectCurPage = this.$refs.addStudentView.getUnSelectCurPage()
          debugger
          this.getunAddedStu(this.$refs.addStudentView.pageSize, unSelectCurPage)


          // let selectCurPage = this.$refs.addStudentView.getSelectCurPage()
          // this.getAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    studentNnSelected (item) {
      let requestData = {userid: item.Id, courseid: this.curCourseIdByAddStu}
      this.$api.courseManager.delStuToCourse(requestData).then((res) => {
        if (res.code === 0) {
          let selectCurPage = this.$refs.addStudentView.getSelectCurPage()
          this.getAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)

          this.$refs.addStudentView.unSelectedSuccess(item)
          // let unSelectCurPage = this.$refs.addStudentView.getUnSelectCurPage()
          // this.getunAddedStu(this.$refs.addStudentView.pageSize, unSelectCurPage)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    studentNnSelectPageChange (pageSize, index) {
      this.getunAddedStu(pageSize, index)
    },
    studentSelectPageChange (pageSize, index) {
      this.getAddedStu(pageSize, index)
    },
    studentSearchUnSelectClick (searchKey) {
      let selectCurPage = 1// this.$refs.addStudentView.getUnSelectCurPage()
      this.getunAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)
    },
    studentSearchSelectClick (serachKey) {
      let selectCurPage = 1// this.$refs.addStudentView.getSelectCurPage()
      this.getAddedStu(this.$refs.addStudentView.pageSize, selectCurPage)
    },
    getFirstLiveTime (firstDate) {
      let firstLiveTime = new Date(firstDate).getTime()
      let standardTime = new Date('2018-01-01').getTime()
      if (firstLiveTime < standardTime) {
        return '暂无直播'
      } else {
        return this.formatDate('YYYY-mm-dd HH:MM:SS', firstDate)
      }
    },
    formatDate (fmt, dateStr) {
      let date = new Date(dateStr)
      let ret
      let opt = {
        'Y+': date.getFullYear().toString(),
        'm+': (date.getMonth() + 1).toString(),
        'd+': date.getDate().toString(),
        'H+': date.getHours().toString(),
        'M+': date.getMinutes().toString(),
        'S+': date.getSeconds().toString()
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
      };
      return fmt
    },
    getCourseTypeStr (courseType) {
      switch (courseType) {
        case 0 :
          return '小班课'
        case 1 :
          return '大班课'
        case 2 :
          return '公开课'
        case 5 :
          return '双师课'
        default:
          return 'type:' + courseType
      }
    }
  }
}
</script>

<style scoped>
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    text-align: justify;
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .search-container{
    margin: 20px;
    height: 130px;
    background-color: #EFF1F6;
  }
</style>



// WEBPACK FOOTER //
// src/page/courseManager/CourseManager.vue